import { axiosInstance as request } from '@api/rest.service'

const api = '/meta-data-fields'

/**
 * @description GET /meta-data-fields/create
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_FIELDS_CREATE = () => request.get(`${api}/create`)

/**
 * @description GET /meta-data-fields
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_FIELDS = () => request.get(api)

/**
 * @description POST /meta-data-fields
 * @returns {AxiosPromise<any>}
 */
export const CREATE_METADATA_FIELD = payload => request.post(api, payload)

/**
 * @description PUT /meta-data-fields/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_METADATA_FIELD = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /meta-data-fields/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_FIELD_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /meta-data-fields/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_METADATA_FIELD = id => request.delete(`${api}/${id}`)
